export default __webpack_public_path__ + "static/media/template4.da125b8a.jpg";